import React from 'react'

import { InputMask, Row, Button, Form, Grid, Input } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

interface IFilterTableServicesDjur {
  handleSubmit: (_data: any) => void
  handleCleanFields: () => void
  control: any
  errors: any
  watch: any
}

const FilterTableServicesDjur: React.FC<IFilterTableServicesDjur> = ({
  control,
  errors,
  watch,
  handleSubmit,
  handleCleanFields
}) => {
  const cnpjCpfPassaporte = watch('cnpjCpfPassaporte')
  const cpfPassaporte = watch('cpfPassaporte')

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Grid
          gridCols="1fr 1fr 1fr 1fr 2fr 1fr 1fr"
          gridGap={`0 ${SPACING.spacing10}`}
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          <InputMask
            control={control}
            errors={errors}
            formValue="cdContrato"
            label="Contrato"
            placeholder="Nº"
            marginRight={SPACING.spacing15}
            maxLength={15}
          />

          <InputMask
            control={control}
            errors={errors}
            formValue="numeroAtendimentoDjur"
            label="Atendimento DJUR"
            placeholder="Nº"
            type="number"
            marginRight={SPACING.spacing15}
            maxLength={15}
          />

          <Input
            control={control}
            errors={errors}
            formValue="cervello"
            label="Cervello"
            placeholder="Nº"
            maxLength={15}
          />

          <Input
            control={control}
            errors={errors}
            formValue="cnpjCpfPassaporte"
            label="CPF/CNPJ/Cód.Fornecedor"
            mask={
              cnpjCpfPassaporte && cnpjCpfPassaporte.length > 9 
              ? ['###.###.###-##', '##.###.###/####-##']
              : ['#########']
            }
            placeholder="Nº"
          />

          <InputMask
            control={control}
            errors={errors}
            formValue="nomeFornecedor"
            label="Nome do Fornecedor"
            placeholder="Nome do Fornecedor"
            maxLength={80}
          />

          <Input
            control={control}
            errors={errors}
            formValue="cpfPassaporte"
            mask={
              isNaN(parseInt(cpfPassaporte))
                ? ['NN############']
                : ['###.###.###-##']
            }
            label="CPF/Passaporte"
            maxLength={14}
            placeholder="Nº"
          />
          <Input
            control={control}
            errors={errors}
            formValue="numeroProcesso"
            label="Processo"
            placeholder="Nº"
          />
        </Grid>
        <Row marginBottom={SPACING.spacing30} justifyContent="flex-end">
          <Button
            text="Limpar"
            variantButton="text"
            onClick={handleCleanFields}
            marginRight={SPACING.spacing30}
          />
          <Button
            endIcon={<MagnifyingGlassIcon />}
            text="Pesquisar"
            variantButton="default"
            type="submit"
          />
        </Row>
      </Form>
    </>
  )
}

export default FilterTableServicesDjur
